import { createFileRoute } from "@tanstack/react-router";

import OpsDashboard from "~/pages/MeqLive/OpsDashboard";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/meq-live/")({
  staticData: ROUTE_STATIC.meqLive,
  component: OpsDashboard,
});
